export const environment = {
    production: false,
    backendURL: "https://sbolcanvas-api.victoriouswater-326a4bf8.westcentralus.azurecontainerapps.io/api",
    baseURI: "https://sbolcanvas.org"
};
